import InputBox from "../../../../Component/DigitalMarketing/Forms/InputBox";
import SelectDropdown from "../../../../Component/DigitalMarketing/Forms/SelectDropdown";

export type ItemType = {
  tag: any;
  label: string;
  type?: string;
  placeholder?: string;
  key_name?: string;
  style?: string;
  end_point?: any; // Update the type to any or a specific type
  styles?: any; // Update the type to any or a specific type
};
export let statuss = [
  {
    label: "Active",
    value: 1,
    icon: "green",
  },
  {
    label: "Inactive",
    value: 2,
    icon: "red",
  },
];
export const PatientDetailsLabel: ItemType[] = [
  {
    tag: InputBox,
    label: "Patient Name",
    type: "text",
    placeholder: "Enter patient name",
    key_name: "customerName",
    style: "input-grey",
  },
  {
    tag: InputBox,
    label: "Mobile No",
    type: "text",
    placeholder: "Enter mobile no",
    key_name: "phone1",
    style: "input-grey",
  },
  {
    tag: InputBox,
    label: "Location",
    type: "text",
    placeholder: "Enter location",
    key_name: "city",
    style: "input-grey",
  },
  {
    tag: InputBox,
    label: "Service Chosen",
    type: "text",
    placeholder: "Enter service choosen",
    key_name: "serviceChoosen",
    style: "input-grey",
  },
  { tag: SelectDropdown, label: "Status", styles: "select" ,key_name:'customerStatus',end_point:'progressStatus'},
  {
    tag: InputBox,
    label: "Last Contacted",
    type: "text",
    key_name: "lastContacted",
    style: "input-grey",
  },
];
export const ServiceChosen = [
  { imgPath: require('../../../../assets/DigitalMarketing/image/customer/status/whatsapp.png'), label: 'Mimo', selPath: require('../../../../assets/DigitalMarketing/image/customer/status/whatsapp_sel.png') },
  { imgPath: require('../../../../assets/DigitalMarketing/image/customer/status/apple.png'), label: 'Bootcamp', selPath: require('../../../../assets/DigitalMarketing/image/customer/status/apple_sel.png') },
  { imgPath: require('../../../../assets/DigitalMarketing/image/customer/status/clinic.png'), label: 'Fertility Clinic', selPath: require('../../../../assets/DigitalMarketing/image/customer/status/clinic_sel.png') },
  { imgPath: require('../../../../assets/DigitalMarketing/image/customer/status/preganancy.png'), label: 'Pregnancy', selPath: require('../../../../assets/DigitalMarketing/image/customer/status/preganancy_sel.png') },
];
export const SetAppointmentLabel= [
  {
    tag: InputBox,
    label: "Date",
    type: "date",
    key_name: "appointmentDate",
  },
  {
    tag: InputBox,
    label: "Time",
    type: "time",
    key_name: "appointmentTime",
  },
]
export const SetReminderLabel= [
  {
    tag: InputBox,
    label: "Start date",
    type: "date",
    key_name: "fromDate",
    // msg:'This is used to select start date.'
  },
  {
    tag: InputBox,
    label: "End date",
    type: "date",
    key_name: "toDate",
    // msg:'This is used to select End date.'
  },
]